module.exports = __webpack_public_path__ + "img/finance_2.22c2df25.png";